import { Inject, Injectable } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API } from '../constant/api';
import { LobbyConstant } from '../constant/lobby.constant';
import { BetLimit } from '../models/betlimit';
import { FC21Lobby } from '../models/fc21lobby';
import { FC21RTP } from '../models/fc21rtp';
import { FCBLobby } from '../models/fcblobby';
import { FCBRTP } from '../models/fcbrtp';
import { Game } from '../models/game';
import { Limit } from '../models/limit';
import { Settings } from '../models/settings/settings';
import { HttpService } from '../util/HttpService';
import { UtilService } from '../util/UtilService';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class BetlimitService {
  public fc21Array: Array<FC21Lobby> = [];
  public fcbArray: Array<FCBLobby> = [];
  public fc21JSON: any = {};
  public fcbJSON: any = {};
  private betLimitLoaded = false;
  betLimit: BetLimit = new BetLimit();
  currencyCode = '';
  currencySymbol = '';
  public currentLang = 'en';

  fc21JSONSubject = new BehaviorSubject<any>({});

  dealersArray = new BehaviorSubject<any>({});

  constructor(
    @Inject(HttpService) private http: HttpService,
    public userService: UserService,
    public utilService: UtilService,
    public translate: TranslateService
  ) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLang = translate.currentLang;
    });
  }

  getBetLimit(): Observable<any> {
    return this.http.post(API.BET_LIMIT, {}).pipe(
      map((response: any) => {
        if ((<string>response?.status).toLowerCase() === 'success') {
          this.betLimitLoaded = true;
          this.setCurrencyCodeAndSymbol(response.currency);
          this.betLimit = <BetLimit>response.betlimit;
          // //console.log(this.betLimit);
        }
        /*(<string>response.status).toLowerCase()*/
        return response;
      })
    );
    /*.subscribe((response: any) => {
     //console.log(response);
     if ((<string>response.status).toLowerCase() === 'success') {
     this.userService.user.currencyCode = response.currency;
     this.betLimit = <BetLimit>response.betlimit;
     //console.log(this.betLimit);
     }
     });*/
  }
  getLiveDealerBetLimit(): Observable<any> {
    /* https://fcgrngdev.redimstg.com/cgibin/Lobby?gametype=0000000000000606&action=LiveDealerTables */
    let batLimitLDobj: any = {};
    batLimitLDobj.gametype = '0000000000000606';
    batLimitLDobj.action = 'LiveDealerTables';
    return this.http.get(API.LIVEDEALERTABLES, batLimitLDobj).pipe(
      map((response: any) => {
        //console.log('getLiveDealerBetLimit Response: ', response);
        const limitArr = response.map((tableid) => {
          //console.log('tableid' , tableid);
          let tablelimit = new Limit();
          tablelimit.title = tableid;
          tablelimit.min = 0;
          tablelimit.max = 0;
          tablelimit.tableid = tableid;
          return tablelimit;
        });
        return limitArr;
      })
    );
  }
  getAvailableSeatTableInfo(tableID): Observable<any> {
    //console.log('getAvailableSeatTableInfo', tableID);
    const tableObj: any = {};
    tableObj.tableid = tableID;
    tableObj.gametype = '0000000000000606';
    tableObj.action = 'AvailableSeatTableInfo';
    return this.http.get(API.LIVEDEALERTABLES, tableObj).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  makeQueuedUserRedirectToLD(): Observable<any> {
    const tableObj: any = {};
    tableObj.action = 'QueuedUserRedirectToLD';
    return this.http.get(API.LIVEDEALERTABLES, tableObj).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  makeRemoveFromQueue(): Observable<any> {
    const tableObj: any = {};
    tableObj.action = 'removeFromQueue';
    return this.http.get(API.LIVEDEALERTABLES, tableObj).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  addQueuedPlayersInfo(): Observable<any> {
    //console.log('addQueuedPlayersInfo');
    const tableObj: any = {};
    tableObj.userId = this.userService.user.userId;
    tableObj.action = 'QueuedPlayers';
    return this.http.get(API.LIVEDEALERTABLES, tableObj).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  getLiveBetLimitByID(tableID): Observable<any> {
    //console.log('getLiveBetLimitByID', tableID);
    const tableObj: any = {};
    tableObj.tableId = tableID;
    tableObj.action = 'LiveDealerBetlimitByTableId';
    tableObj.playerlevel = 1;
    tableObj.currency = this.currencyCode.toUpperCase();
    return this.http.get(API.LIVEDEALERTABLES, tableObj).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  getFCG21RTP(): Observable<any> {
    const tableObj: any = {};
    tableObj.action = 'FCG21RTP';
    return this.http.get(API.LIVEDEALERTABLES, tableObj).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  getLiveRoadMapByID(tableID, max = 16): Observable<any> {
    //https://fcgrngdev.redimstg.com/cgibin/Lobby?tableId=fcg21nv8sv7rk1jk&action=DealerGameResult&max=25&betLimit=1&playerlevel=1&currency=USD
    //console.log('getLiveBetLimitByID', tableID);
    const tableObj: any = {};
    tableObj.tableId = tableID;
    tableObj.action = 'DealerGameResult';
    tableObj.playerlevel = 1;
    tableObj.max = max;
    tableObj.betLimit = 1;
    tableObj.currency = this.currencyCode.toUpperCase();
    return this.http.get(API.LIVEDEALERTABLES, tableObj).pipe(
      map((response: any) => {
        return response;
      })
    );
  }
  playForFunCheckLogin(data): Observable<any> {
    let tokenObj: any = {};
    tokenObj.requesttype = data;
    //console.log("old -- this.userService.user.sessiontoken",tokenObj);
    //console.log("sessiontoken old -- this.userService.user.sessiontoken",this.userService.user.sessiontoken);
    return this.http.post(API.PLAYFOR_FUN, tokenObj, true, 'json', false).pipe(
      map((response: any) => {
        //console.log("response new sessiontoken",response)
        if ((<string>response.statusmessage).toLowerCase() === 'success') {
          console.log(
            'betlimint updating session token with value: ',
            response.sessiontoken
          );
          console.log(
            'updating session token from play for fun with value: ',
            response.sessiontoken
          );
          this.userService.user.sessiontoken = response.sessiontoken;
          //console.log("sessiontoken new -- this.userService.user.sessiontoken",this.userService.user.sessiontoken);
        }
        return response.statusmessage;
      })
    );
  }

  setBetLimitForLocalEnv() {
    const betLimitStr =
      '{"currency":"BTC","betlimit":{"fcg21ornothing":{"rng":{"multiplayer":{"limits":{"5":[{"title":"private","betlimitid":1,"privacy":false,"min":5.0,"max":50.0},{"title":"regular","betlimitid":2,"privacy":false,"min":10.0,"max":100.0},{"title":"highroller","betlimitid":3,"privacy":false,"min":25.0,"max":250.0},{"title":"vip","betlimitid":4,"privacy":false,"min":50.0,"max":500.0},{"title":"vvip","betlimitid":5,"privacy":false,"min":100.0,"max":1000.0}]},"fcg21ornothingrtp":{"decks":"8","shufflepercentage":"50","split":"5-9","soft17":"true","supernatural":"2:1","naturaltwentyone":"3:2","doublenatural":"1:1","naturalzero":"1:1","colorcardinsurance":"2:1","whitecardinsurance":"2:1","russianroulette17":"6:5","russianroulette18":"7:5","russianroulette19":"2:1","russianroulette20":"7:2","maxbet":1000.0,"minbet":5.0,"betlimitid":0}},"privatetable":{"limits":{"2":[{"title":"private_lowroller","betlimitid":6,"privacy":true,"min":5.0,"max":50.0},{"title":"private_regular","betlimitid":7,"privacy":true,"min":10.0,"max":100.0},{"title":"private_highroller","betlimitid":8,"privacy":true,"min":25.0,"max":250.0},{"title":"private_vip","betlimitid":9,"privacy":true,"min":50.0,"max":500.0},{"title":"private_vvip","betlimitid":10,"privacy":true,"min":100.0,"max":1000.0}],"3":[{"title":"private_lowroller","betlimitid":6,"privacy":true,"min":5.0,"max":50.0},{"title":"private_regular","betlimitid":7,"privacy":true,"min":10.0,"max":100.0},{"title":"private_highroller","betlimitid":8,"privacy":true,"min":25.0,"max":250.0},{"title":"private_vip","betlimitid":9,"privacy":true,"min":50.0,"max":500.0},{"title":"private_vvip","betlimitid":10,"privacy":true,"min":100.0,"max":1000.0}],"5":[{"title":"private_lowroller","betlimitid":6,"privacy":true,"min":5.0,"max":50.0},{"title":"private_regular","betlimitid":7,"privacy":true,"min":10.0,"max":100.0},{"title":"private_highroller","betlimitid":8,"privacy":true,"min":25.0,"max":250.0},{"title":"private_vip","betlimitid":9,"privacy":true,"min":50.0,"max":500.0},{"title":"private_vvip","betlimitid":10,"privacy":true,"min":100.0,"max":1000.0}]},"fcg21ornothingrtp":{"decks":"8","shufflepercentage":"50","split":"5-9","soft17":"true","supernatural":"2:1","naturaltwentyone":"3:2","doublenatural":"1:1","naturalzero":"1:1","colorcardinsurance":"2:1","whitecardinsurance":"2:1","russianroulette17":"6:5","russianroulette18":"7:5","russianroulette19":"2:1","russianroulette20":"7:2","maxbet":1000.0,"minbet":5.0,"betlimitid":0}}},"livedealer":{"multiplayer":{"limits":{"7":[{"betlimitid":0,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":1,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":2,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":3,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":4,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":5,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":6,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":7,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":8,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":9,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":10,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":11,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":12,"privacy":false,"min":5.0,"max":1000.0},{"betlimitid":13,"privacy":false,"min":5.0,"max":1000.0}]},"fcg21ornothingrtp":{"decks":"8","shufflepercentage":"50","split":"5-9","soft17":"true","supernatural":"2:1","naturaltwentyone":"3:2","doublenatural":"1:1","naturalzero":"1:1","colorcardinsurance":"2:1","whitecardinsurance":"2:1","russianroulette17":"6:5","russianroulette18":"7:5","russianroulette19":"2:1","russianroulette20":"7:2","maxbet":1000.0,"minbet":5.0,"betlimitid":0}}}},"fcgbaccarat":{"rng":{"privatetable":{"limits":{"1":[{"title":"private_lowroller","betlimitid":6,"privacy":true,"min":5.0,"max":50.0},{"title":"private_regular","betlimitid":7,"privacy":true,"min":10.0,"max":100.0},{"title":"private_highroller","betlimitid":8,"privacy":true,"min":25.0,"max":250.0},{"title":"private_vip","betlimitid":9,"privacy":true,"min":50.0,"max":500.0},{"title":"private_vvip","betlimitid":10,"privacy":true,"min":100.0,"max":1000.0}]},"fcgbaccaratrtp":{"commission":"5","decks":"8","shufflepercentage":"96","tie":"6:1","minustwo":"1:1","plustwo":"1:1","minusthree":"5:1","plusthree":"3:1","minbet":5.0,"maxbet":1000.0}}},"livedealer":{"privatetable":{"limits":{"1":[{"betlimitid":0,"privacy":false,"min":5.0,"max":100.0}]},"fcgbaccaratrtp":{"commission":"5","decks":"8","shufflepercentage":"96","tie":"8:1","minustwo":"1:1","plustwo":"1:1","minusthree":"5:1","plusthree":"3:1","minbet":5.0,"maxbet":100.0}}}}},"status":"Success","statuscode":0}';
    const betLimitObj = JSON.parse(betLimitStr);
    this.setCurrencyCodeAndSymbol(betLimitObj.currency);
    this.betLimit = <BetLimit>betLimitObj.betlimit;
  }

  setCurrencyCodeAndSymbol(currencyCode) {
    this.userService.user.currencyCode = currencyCode;
    this.currencyCode = currencyCode;
    this.currencySymbol = this.utilService.setCurrencySymbol(
      this.userService.user.currencyCode,
      true
    );
  }

  getAppSettings(isDesktop: boolean) {
    if (Settings.appSettings.lobby) {
      return isDesktop
        ? Settings.appSettings.lobby.fc21
        : Settings.appSettings.lobby.fc21mobile;
    }
    console.warn("Couldn't find app settings.");
    return undefined;
  }

  setFC21Data = (isDesktop = true) => {
    this.fc21Array = isDesktop
      ? [...LobbyConstant.FC21]
      : [...LobbyConstant.MOBLEFC21];

    const appSettings = this.getAppSettings(isDesktop);

    this.fc21Array.forEach((gameLobby: FC21Lobby, index: number) => {
      this.updateGameLobby(
        gameLobby,
        appSettings ? appSettings[index] : undefined
      );
    });

    return this.fc21Array;
  };

  updateGameLobby(gameLobby: FC21Lobby, appSetting?: any) {
    if (this.betLimit[gameLobby.game]) {
      if (appSetting) {
        gameLobby.isComingSoon = appSetting.isComingSoon;
        gameLobby.isSecret = appSetting.isSecret;
      }

      const game: Game =
        this.betLimit[gameLobby.game]?.[gameLobby.gameType]?.[
          gameLobby.tableType
        ];
      gameLobby.tableLimits = `${this.currencySymbol}5-${this.currencySymbol}1000`;

      if (game) {
        this.setGameLimits(gameLobby, game);
      } else {
        if (this.currentLang === 'ar' || this.currentLang === 'he') {
          gameLobby.shuffles = `%${gameLobby.shuffles.split('%')[0]}`;
        }
      }
    }

    this.fc21JSON[gameLobby.featureName] = gameLobby;
    this.fc21JSONSubject.next({
      [gameLobby.featureName]: gameLobby,
      ...this.fc21JSONSubject.value,
    });
  }

  setGameLimits(gameLobby: FC21Lobby, game: Game) {
    const rtp: FC21RTP = game[`${gameLobby.game}rtp`];
    gameLobby.minbet = rtp.minbet;
    gameLobby.maxbet = rtp.maxbet;
    gameLobby.tableLimits = `${this.currencySymbol}${rtp.minbet}-${this.currencySymbol}${rtp.maxbet}`;
    this.updateRTP(gameLobby, rtp);
    gameLobby.limits = [...game['limits']?.[gameLobby.seat]];

    if (gameLobby.featureName === 'livecasino') {
      this.addNewTableLimit(gameLobby, 'newtable');
    }
    if (gameLobby.featureName === 'private') {
      this.addNewTableLimit(gameLobby, 'viptable');
    }
  }

  addNewTableLimit(gameLobby: FC21Lobby, title: string) {
    const newTableLimits: Limit = new Limit();
    newTableLimits.title = title;
    newTableLimits.betlimitid = 0;
    gameLobby.limits.push(newTableLimits);
  }

  updateRTP(gameLobby, rtp) {
    if (!rtp) {
      console.warn(
        'RTP not found. Skipping update. API endpoint: /cgibin/Lobby'
      );
      return;
    }
    gameLobby.decks = rtp.decks;
    gameLobby.splits = rtp.split;
    gameLobby.soft17 = rtp.soft17 === 'true' ? true : false;
    gameLobby.insurance = rtp.colorcardinsurance;
    gameLobby.supernatural = rtp.supernatural;
    gameLobby.naturaltwentyone = rtp.naturaltwentyone;
    gameLobby.doublenatural = rtp.doublenatural;
    gameLobby.naturalzero = rtp.naturalzero;
    if (this.currentLang == 'ar' || this.currentLang == 'he') {
      const insuranceProperties = [
        'colorcardinsurance',
        'whitecardinsurance',
        'russianroulette17',
        'russianroulette18',
        'russianroulette19',
        'russianroulette20',
      ];

      insuranceProperties.forEach((property) => {
        const [left, right] = rtp[property].split(':').map(Number);
        gameLobby[property] = `${left} : ${right} / ${this.getRatioPercentage(
          rtp[property]
        )}`;
      });
    } else {
      gameLobby.shuffles = rtp.shufflepercentage + '%';
      const insuranceProperties = [
        'colorcardinsurance',
        'whitecardinsurance',
        'russianroulette17',
        'russianroulette18',
        'russianroulette19',
        'russianroulette20',
      ];

      insuranceProperties.forEach((key) => {
        gameLobby[key] =
          `${rtp[key]}` + ' / ' + ` ${this.getRatioPercentage(rtp[key])}`;
      });
      const percentageProperties = [
        'supernatural',
        'naturaltwentyone',
        'doublenatural',
        'naturalzero',
        'colorcardinsurance',
        'whitecardinsurance',
        'russianroulette17',
        'russianroulette18',
        'russianroulette19',
        'russianroulette20',
      ];

      percentageProperties.forEach((key) => {
        gameLobby[`${key}percentage`] = this.getRatiosplitedPercentage(
          rtp[key]
        ).split('%')[0];
      });
    }
  }

  getRatioPercentage(ratioString) {
    const [numerator, denominator] = ratioString.split(':').map(Number);
    const percentage = Math.floor((numerator / denominator) * 100);
    return this.currentLang === 'ar' || this.currentLang === 'he'
      ? `${percentage} %`
      : `${percentage}%`;
  }

  getRatiosplitedPercentage(ratioString) {
    const [numerator, denominator] = ratioString.split(':').map(Number);
    const percentage = Math.floor((numerator / denominator) * 100);
    return this.currentLang === 'ar' || this.currentLang === 'he'
      ? `${percentage} %`
      : `${percentage}%`;
  }

  getCurrencySymbolByCode(code) {
    return this.utilService.setCurrencySymbol(code);
  }

  setFCBData = () => {
    this.fcbArray = [...LobbyConstant.FCB];
    let appSettings;
    if (Settings.appSettings.lobby != undefined) {
      appSettings = Settings.appSettings.lobby.fcb;
    }
    const len = this.fcbArray.length;
    // //console.log('FCB DATA');
    // //console.log(this.betLimit);
    for (let i = 0; i < len; i++) {
      const gameLobby: FCBLobby = this.fcbArray[i];
      if (this.betLimit[gameLobby.game]) {
        if (appSettings != undefined && appSettings[i] != undefined) {
          gameLobby.isComingSoon = appSettings[i].isComingSoon;
          gameLobby.isSecret = appSettings[i].isSecret;
        }
        const game: Game =
          this.betLimit[gameLobby.game][gameLobby.gameType][
            gameLobby.tableType
          ];
        gameLobby.tableLimits =
          this.currencySymbol + 5 + '-' + this.currencySymbol + 1000;
        if (game) {
          const rtp: FCBRTP = game[gameLobby.game + 'rtp'];
          gameLobby.commission = '0% ~ ' + rtp.commission + '%';
          gameLobby.decks = rtp.decks;
          gameLobby.shuffles = rtp.shufflepercentage + '%';
          gameLobby.tableLimits =
            this.currencySymbol +
            rtp.minbet +
            '-' +
            this.currencySymbol +
            rtp.maxbet;
          gameLobby.tie = rtp.tie + ' / ' + this.getRatioPercentage(rtp.tie);
          gameLobby.minbet = rtp.minbet;
          gameLobby.maxbet = rtp.maxbet;
          gameLobby.minusthree =
            rtp.minusthree + ' / ' + this.getRatioPercentage(rtp.minusthree);
          gameLobby.minustwo =
            rtp.minustwo + ' / ' + this.getRatioPercentage(rtp.minustwo);
          gameLobby.plusthree =
            rtp.plusthree + ' / ' + this.getRatioPercentage(rtp.plusthree);
          gameLobby.plustwo =
            rtp.plustwo + ' / ' + this.getRatioPercentage(rtp.plustwo);
          gameLobby.limits = [
            ...this.betLimit[gameLobby.game][gameLobby.gameType][
              gameLobby.tableType
            ]['limits'][gameLobby.seat],
          ];
          if (gameLobby.featureName === 'private') {
            const newTableLimits: Limit = new Limit();
            newTableLimits.title = 'viptable';
            newTableLimits.betlimitid = 0;
            gameLobby.limits.push(newTableLimits);
          }
        }
      }
      this.fcbJSON[gameLobby.featureName] = gameLobby;
    }
    return this.fcbArray;
  };

  get isBetLimitLoaded(): boolean {
    return this.betLimitLoaded;
  }
}
